var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 8,
    viewBox: "0 0 9 8",
    width: 9,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.3669 7.74981L0.247041 5.60663C-0.0823469 5.27372 -0.0823469 4.73351 0.247041 4.40016C0.577583 4.06623 1.11174 4.06623 1.4417 4.40016L2.83665 5.80882L7.45298 0.376971C7.71364 -0.0139988 8.23884 -0.117722 8.62627 0.145598C9.01386 0.407752 9.11595 0.938916 8.85703 1.33032L3.66539 7.62216C3.52373 7.83413 3.29759 7.97097 3.04604 7.99548C3.01889 7.99767 2.99189 8 2.96416 8C2.74077 8 2.52647 7.90999 2.3669 7.74981Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconBlack);
export default __webpack_public_path__ + "static/media/check_icon_black.b032825c592a7f6ff50c5a6835c4b01c.svg";
export { ForwardRef as ReactComponent };